(function () {

    'use strict';

    angular.module('iplusjs.list.table', [
        'lodash',
        'iplusjs.utils.scrollToTop',
        'iplusjs.utils.scrollIntoView',
        'iplusjs.utils.focusFirst',
        'iplusjs.filter.toTrusted'
    ])
        .component('iplusjsTableList', {
            bindings: {
                items: '<itlItems',
                selectedItem: '<itlSelectedItem',
                columns: '<itlColumns',
                emptyText: '@?itlEmptyText',
                onSelect: '&itlOnSelect',
                onListNavigation: '&itlOnListNavigation',
                isLoading: '<itlIsLoading',
                options: '<itlOptions'
            },
            templateUrl: 'common/list/tableList.html',
            controller: TableListController,
            controllerAs: 'tableListVm'
        });

    TableListController.$inject = [
        '$element',
        '$compile',
        '$timeout',
        'lodash'
    ];
    function TableListController($element, $compile, $timeout, _) {
        var vm = this,
            keyCodes = {
                ENTER: 13
            };

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.getColumnBezeichnung = getColumnBezeichnung;
        vm.isListVisible = isListVisible;
        vm.onClick = onClick;
        vm.onKeydown = onKeydown;

        function activate() {
            vm.options = vm.options || {};
            vm.options.scrollToTop = _.isNil(vm.options.scrollToTop) ? true : vm.options.scrollToTop;
            vm.options.scrollToSelected = vm.options.scrollToTop ? null : !!vm.options.scrollToSelected;

            vm.hasItems = !!(vm.items || []).length;
            vm.hasColumns = !!(vm.columns || []).length;
            vm.hasHeaders = _.findKey(vm.columns , function (column) {
                return !_.isNil(column.header);
            });
            vm.emptyText = vm.emptyText || 'Keine Treffer gefunden';
        }

        function onInit() {
            activate();
        }

        function onChanges(changes) {
            activate();

            if (vm.options.scrollToTop) {
                vm.scrollToTop = false;
            }

            if (vm.options.focusFirst) {
                vm.focusFirst = false;
            }

            if (vm.options.scrollToSelected) {
                vm.scrollToSelected = null;
            }

            if (changes.items || changes.columns || changes.options) {
                $timeout(function () {
                    vm.listElement = $element.find('ul')[0];

                    if (vm.options.scrollToTop) {
                        vm.scrollToTop = true;
                    }

                    if (vm.options.focusFirst) {
                        vm.focusFirst = true;
                    }

                    if (vm.options.scrollToSelected && vm.selectedItem) {
                        if (vm.listElement && _.isFunction(vm.listElement.querySelector)) {
                            vm.scrollToSelected = vm.listElement.querySelector('span[data-column-val="' + vm.selectedItem + '"]');
                        }
                    }
                });
            }
        }
        function getColumnBezeichnung(row, column, removeHighlight) {
            var bezeichnung = [],
                columnBezeichnung;

            _.each(column.attr, function (attr) {
                bezeichnung.push(row[attr]);
            });

            columnBezeichnung = bezeichnung.join(_.isNil(column.joinChar) ? ' / ' : column.joinChar);

            return removeHighlight ? (columnBezeichnung || '').replace(/<[^>]*>/g, '') : columnBezeichnung;
        }
        function isListVisible() {
            return vm.hasItems && vm.hasColumns;
        }
        function onClick(item) {
            selectItem(item);
        }
        function onKeydown(event, item) {
            if (event && event.keyCode === keyCodes.ENTER) {
                event.preventDefault();

                selectItem(item);
            } else {
                vm.onListNavigation({
                    event: event,
                    item: item
                });
            }
        }
        function selectItem(item) {
            vm.onSelect({
                item: item
            });
        }
    }
})();
